// extracted by mini-css-extract-plugin
export default {"container":"AkMzm","badge":"hwd9V","button":"hQdEA","icon":"-CT6V"};